module.exports = ".text-upper-case {\r\n  text-transform: uppercase;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/steps/guest-credit-step/guest-credit-step.component.css
// module id = ./src/app/steps/guest-credit-step/guest-credit-step.component.css
// module chunks = main